<template>
	<div class="user-details-form-wrapper">
		<div class="section-header">
			{{ $t("userDetailsForm.header") }}
		</div>
		<div class="section-subheader">
			{{ $t("userDetailsForm.subheader") }}
		</div>
		<div class="form-wrapper">
			<div class="input-wrapper">
				<div class="label">
					{{ $t("userDetailsForm.label.name") }}
				</div>
				<input
					type="text"
					class="strip-input-default-styles"
					:placeholder="$t('userDetailsForm.placeholder.name')"
					v-model="name"
				/>
				<div v-show="false" class="error-message-wrapper"></div>
			</div>
			<div class="input-wrapper">
				<div class="label">
					{{ $t("userDetailsForm.label.email") }}
				</div>
				<input
					type="text"
					class="strip-input-default-styles"
					:placeholder="$t('userDetailsForm.placeholder.email')"
					v-model="email"
				/>
				<div v-show="false" class="error-message-wrapper"></div>
			</div>
			<div class="input-wrapper">
				<div class="label">
					{{ $t("userDetailsForm.label.phone") }}
				</div>
				<input
					type="text"
					class="strip-input-default-styles"
					:placeholder="$t('userDetailsForm.placeholder.phone')"
					v-model="phone"
				/>
				<div v-show="false" class="error-message-wrapper"></div>
			</div>
			<div class="input-wrapper">
				<div class="label">
					{{ $t("userDetailsForm.label.pincode") }}
				</div>
				<input
					type="text"
					class="strip-input-default-styles"
					:placeholder="$t('userDetailsForm.placeholder.pincode')"
					v-model="pincode"
				/>
				<div v-show="false" class="error-message-wrapper"></div>
			</div>
		</div>
		<div class="page-footer">
			<div class="footer-button" @click.stop="handleFormSubmit">
				{{ $t("buttonText.next") }}
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from "vuex";
export default {
	name: "UserDetailsForm",
	components: {},
	data: () => ({
		name: "",
		email: "",
		phone: "",
		pincode: "",
	}),
	computed: {},
	async mounted() {},
	destroyed() {},
	methods: {
		...mapActions(["createCustomer"]),
		handleFormSubmit() {
			this.createCustomer({
				name: this.name,
				email: this.email,
				contactNumber: this.phone,
				pincode: this.pincode,
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.user-details-form-wrapper {
	height: 100%;
	width: 100%;
	padding: 0 1rem;
	padding-top: 1.5rem;
	padding-bottom: calc(1.3125rem + 2.6875rem + 1.5rem + 1.125rem);
	position: relative;

	display: flex;
	flex-direction: column;
	align-items: center;

	@include custom-min(768px) {
		padding-top: 3rem;
		padding-bottom: calc(1.3125rem + 2.6875rem + 1.5rem + 1.125rem * 2);
	}

	.section-header {
		font-family: $heading-font;
		font-style: normal;
		font-weight: 400;
		font-size: 1.25rem;
		line-height: 140%;
		text-align: center;
		width: 91%;

		@include custom-min(768px) {
			font-size: 2rem;
		}
	}

	.section-subheader {
		font-style: normal;
		font-weight: 400;
		font-size: 0.875rem;
		line-height: 150%;
		text-align: center;
		margin-top: 0.75rem;
		// padding: 0 1rem;
		width: 91%;

		@include custom-min(768px) {
			font-size: 1.25rem;
			margin-top: 1rem;
		}
	}

	.form-wrapper {
		margin-top: 1.5rem;
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;

		@include custom-min(768px) {
			margin-top: 2rem;
		}

		.input-wrapper {
			margin-bottom: 1.5rem;
			width: 100%;
			text-align: center;

			.label {
				display: none;

				@include custom-min(768px) {
					display: block;
					font-style: normal;
					font-weight: 400;
					font-size: 1rem;
					line-height: 150%;
					opacity: 0.5;
					margin-bottom: 0.75rem;
				}
			}

			@include custom-min(768px) {
				max-width: 26.125rem;
				margin-bottom: 2.125rem;
			}

			input {
				padding: 0.875rem;
				border: 1px solid color(background-light-gray-5);
				text-align: center;
				width: 100%;
			}

			font-weight: 400;
			font-size: 14px;
			line-height: 150%;
			text-align: center;
		}
	}
}
</style>
